import React from 'react';
import clsx from 'clsx';

import { withStyling, IInjectedStylingProps, IStyles } from './higher-order';

import styles from './radio-button-group.module.scss';
import { RadioButton } from './radio-button';

export type RadioButtonItem = {
	id: string;
	label: string;
	description?: string;
};

export interface IRadioButtonGroupProps extends IInjectedStylingProps {
	fullWidth?: boolean;
	id: string;
	items: RadioButtonItem[];
	onChange: (items: RadioButtonItem) => void;
	radioButtonStyles?: IStyles;
	selectedItem?: RadioButtonItem;
	disabledItems?: RadioButtonItem[];
	singleColumn?: boolean;
	disabled?: boolean;
}

const component = (props: IRadioButtonGroupProps): React.JSX.Element => {
	const radioButtonClassnames = clsx(
		props.styling?.getStyle(styles, 'radioButton'),
		props.singleColumn && props.styling?.getStyle(styles, 'singleColumn'),
		props.fullWidth && props.styling?.getStyle(styles, 'fullWidth')
	);

	const handleRadioButtonChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		const selectedItem = props.items.find((item) => item.id === e.currentTarget.id);

		if (selectedItem) {
			props.onChange(selectedItem);
		}
	};

	return (
		<div className={props.styling?.getStyle(styles, 'radioButtonContainer')}>
			<div className={props.styling?.getStyle(styles, 'radioButtonWrapper')}>
				{props.items.length > 0 &&
					props.items.map((item, key) => (
						<div
							key={key}
							className={clsx(
								radioButtonClassnames,
								item.id === props.selectedItem?.id && props.styling?.getStyle(styles, 'checked')
							)}
						>
							<RadioButton
								id={item.id}
								groupName={props.id}
								checked={item.id === props.selectedItem?.id}
								onChange={handleRadioButtonChange}
								propStyles={props.radioButtonStyles || {}}
								fullWidth={props.fullWidth}
								disabled={props.disabled || itemIsDisabled(item, props.disabledItems)}
							>
								{item.description ? (
									<>
										<strong>{item.label}</strong>
										<span>{item.description}</span>
									</>
								) : (
									<>{item.label}</>
								)}
							</RadioButton>
						</div>
					))}
			</div>
		</div>
	);
};

const RadioButtonGroup = withStyling(component);
export { RadioButtonGroup };

const itemIsDisabled = (item: RadioButtonItem, disabledItems?: RadioButtonItem[]): boolean => {
	if (!disabledItems) return false;

	return disabledItems.findIndex((disabledItem) => disabledItem.id === item.id) > -1;
};
